import { Stack, Typography, useTheme } from "@mui/material";
import { Button, CloseIcon, InfoIcon, SingleUserIcon } from "components";
import {
  useFetchResourcesByPermissions,
  useGlobalStore,
  usePermissionStore,
} from "controller";
import { useAtomValue, useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import {
  assigneeData,
  filterNonAccessAssignees,
  setAssignMe,
} from "../store/newTicketStore";
import { PERMISSIONS } from "shared/data";

export const AssigneeBanner = ({ customerId }: { customerId?: string }) => {
  const [assigneeBannerState, setAssigneeBannerState] = useState(false);
  const [isInitial, setIsInitial] = useState(true);

  const [customerChangeBannerState, setCustomerChangeBannerState] =
    useState(false);

  const assignees = useAtomValue(assigneeData);
  const filterNonAccessAssigneesFromStore = useSetAtom(
    filterNonAccessAssignees,
  );
  const haveFullAccess = usePermissionStore((state) =>
    state.hasPermissions([PERMISSIONS.SD.SD_TICKET_ALL_RW]),
  );
  const { data: resources } = useFetchResourcesByPermissions({
    sortColumn: "users.first_name",
    customer_id: customerId,
    serviceType: "tickets",
  });
  useEffect(() => {
    if (
      !haveFullAccess &&
      assignees.apiData.new &&
      Array.isArray(assignees.apiData.new)
    ) {
      setAssigneeBannerState(assignees.apiData.new.length <= 0);
    }
  }, [assignees.apiData.new]);

  useEffect(() => {
    if (
      assignees.apiData.new &&
      customerId &&
      resources?.result &&
      Array.isArray(resources?.result)
    ) {
      filterNonAccessAssigneesFromStore(resources.result);
      if (
        !isInitial &&
        Array.isArray(assignees.apiData.new) &&
        assignees.apiData.new.length > 0
      ) {
        setCustomerChangeBannerState(true);
      }
      setIsInitial(false);
    }
  }, [resources, customerId]);

  const theme = useTheme();
  return (
    <>
      {assigneeBannerState && !haveFullAccess && customerId && (
        <Stack
          sx={{
            position: "absolute",
            top: "-48px",
            height: "48px",
            width: "100%",
            left: "0px",
            bgcolor: theme.palette.warning.tint,
            px: "16px",
          }}
          direction={"row"}
          gap={"32px"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
            <InfoIcon
              sx={{
                height: "20px",
                weight: "20px",
                color: theme.palette.warning.main,
              }}
            />
            <Typography
              variant="body-small"
              sx={{
                "& span": {
                  ...theme.typography["caption"],
                },
              }}
            >
              Please ensure you <span>assign yourself</span> to this ticket, or
              you will lose access to it after it's created.
            </Typography>
          </Stack>
          <CloseIcon onClick={() => setAssigneeBannerState(false)} />
        </Stack>
      )}
      {customerChangeBannerState && (
        <Stack
          sx={{
            position: "absolute",
            top: "-48px",
            height: "48px",
            width: "100%",
            left: "0px",
            bgcolor: theme.palette.warning.tint,
            px: "16px",
          }}
          direction={"row"}
          gap={"32px"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
            <InfoIcon
              sx={{
                height: "20px",
                weight: "20px",
                color: theme.palette.warning.main,
              }}
            />
            <Typography variant="body-small">
              Changing the customer will automatically remove the assignee if
              they don’t have access to the new customer
            </Typography>
          </Stack>

          <CloseIcon onClick={() => setCustomerChangeBannerState(false)} />
        </Stack>
      )}
    </>
  );
};
